export default __webpack_public_path__ + "static/media/angelic-buster.d766c3ba.png";